export function backendUrl(url, slash = true) {
  return slash ? process.env.API_URL + "/" + url : process.env.API_URL + url;
}

export default backendUrl;
